import { render, staticRenderFns } from "./selfAnalysis.vue?vue&type=template&id=3c7794e0&scoped=true&"
import script from "./selfAnalysis.vue?vue&type=script&lang=js&"
export * from "./selfAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./selfAnalysis.vue?vue&type=style&index=0&id=3c7794e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7794e0",
  null
  
)

export default component.exports